// import React, { useState, useEffect } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { translateText } from "../utils/translateText";
// import { useTranslation } from "react-i18next";
// const API = "https://api.mahal.qa/api";

// const CheckItems = () => {
//   const navigate = useNavigate();

//   const [addresses, setAddresses] = useState([]);
//   const [selectedId, setSelectedId] = useState(null);
//   const [showForm, setShowForm] = useState(false);
//   const [showAddressPopup, setShowAddressPopup] = useState(false);
//   const [editId, setEditId] = useState(null);
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   const selectedAddress = addresses.find((a) => a.id === selectedId);

//   const [coords, setCoords] = useState(null);
//   const { i18n } = useTranslation();

//   const [uiText, setUiText] = useState({});
//   // ✅ CREDIT STATES
//   // const [paymentMethod, setPaymentMethod] = useState("COD");
//   // const [paymentMethod, setPaymentMethod] = useState("");
//   const [creditInfo, setCreditInfo] = useState(null);

//   const [formData, setFormData] = useState({
//     name: "",
//     phone: "",
//     altPhone: "",
//     pincode: "",
//     address1: "",
//     address2: "",
//     city: "",
//     state: "",
//     landmark: "",
//     type: "Home",
//   });
//   useEffect(() => {
//     const token = localStorage.getItem("token");
//     if (!token) return;

//     fetch(`${API}/restaurant/profile`, {
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//     })
//       .then((res) => res.json())
//       .then((user) => {
//         const newId = Date.now();

//         // ✅ form set
//         setFormData({
//           name: user?.name || "",
//           phone: user?.phone || "",
//           altPhone: "",
//           pincode: "",
//           address1: "",
//           address2: "",
//           city: "",
//           state: "",
//           landmark: "",
//           type: "Home",
//         });

//         // ✅ address create HERE (IMPORTANT)

//         setSelectedId(newId);
//       })
//       .catch((err) => console.log(err));
//   }, []);
//   /* ================= CREDIT FETCH ================= */
//   useEffect(() => {
//     const token = localStorage.getItem("token");
//     if (!token) return;

//     fetch(`${API}/restaurant/credit-info`, {
//       headers: { Authorization: `Bearer ${token}` },
//     })
//       .then((res) => res.json())
//       .then(setCreditInfo)
//       .catch(() => {});
//   }, []);

//   /* ================= AUTO LOCATION ================= */
//   /* ================= AUTO LOCATION ================= */
//   /* ================= AUTO LOCATION ================= */
//   useEffect(() => {
//     if (navigator.geolocation) {
//       navigator.geolocation.getCurrentPosition(
//         async (pos) => {
//           const { latitude, longitude } = pos.coords;

//           setCoords({
//             lat: latitude,
//             lng: longitude,
//           });

//           try {
//             const res = await fetch(
//               `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`,
//             );

//             const data = await res.json();

//             const addressText = data.display_name || "Current Location";

//             // ✅ CURRENT LOCATION OBJECT
//             const tokenUser = JSON.parse(localStorage.getItem("user") || "{}");

//             const currentLocationAddress = {
//               id: "current-location",

//               // ✅ USER NAME
//               name: formData.name || tokenUser?.name || "Current Location",

//               // ✅ USER PHONE
//               phone: formData.phone || tokenUser?.phone || "",

//               address: addressText,

//               isDefault: false,
//             };

//             setAddresses((prev) => {
//               // ✅ REMOVE OLD CURRENT LOCATION
//               const savedAddresses = prev.filter(
//                 (a) => a.id !== "current-location",
//               );

//               // ✅ KEEP MANUAL SAVED ADDRESSES
//               // ✅ ADD ONLY LATEST CURRENT LOCATION
//               return [currentLocationAddress, ...savedAddresses];
//             });

//             // ✅ SELECT CURRENT LOCATION
//             setSelectedId("current-location");
//           } catch (err) {
//             console.log(err);
//           }
//         },

//         (err) => {
//           console.log("Location error:", err);
//         },
//       );
//     }
//   }, []);
//   /* ================= USER AUTO FILL ================= */

//   useEffect(() => {
//     const fetchSavedAddresses = async () => {
//       try {
//         const res = await fetch(`${API}/user-addresses`);

//         const data = await res.json();

//         if (Array.isArray(data) && data.length > 0) {
//           const formatted = data.map((addr) => ({
//             id: addr.id,

//             name: addr.contact_name,

//             phone: addr.phone,

//             address: addr.address_line,

//             isDefault: addr.is_default,

//             // ✅ EXTRA FIELDS
//             street: addr.street,

//             zone: addr.zone,

//             building: addr.building,

//             unit_no: addr.unit_no,

//             city: addr.city,

//             country: addr.country,

//             zip_code: addr.zip_code,

//             address_type: addr.address_type,
//           }));

//           setAddresses((prev) => {
//             const currentLocation = prev.find(
//               (a) => a.id === "current-location",
//             );

//             // ✅ CURRENT LOCATION EXISTS
//             if (currentLocation) {
//               const allAddresses = [currentLocation, ...formatted];

//               // ✅ FIND DEFAULT
//               const defaultAddress = formatted.find((a) => a.isDefault);

//               // ✅ AUTO SELECT DEFAULT
//               if (defaultAddress) {
//                 setSelectedId(defaultAddress.id);
//               } else if (!selectedId) {
//                 setSelectedId(allAddresses[0].id);
//               }

//               return allAddresses;
//             }

//             // ✅ NO CURRENT LOCATION
//             const defaultAddress = formatted.find((a) => a.isDefault);

//             if (defaultAddress) {
//               setSelectedId(defaultAddress.id);
//             }

//             return formatted;
//           });
//         }
//       } catch (err) {
//         console.log("Address fetch error", err);
//       }
//     };

//     fetchSavedAddresses();
//   }, []);

//   useEffect(() => {
//     const loadTranslations = async () => {
//       if (i18n.language !== "ar") {
//         setUiText({
//           businessCredit: "Business Credit",
//           limit: "Limit",
//           used: "Used",
//           available: "Available",
//           creditPeriod: "Credit Period",
//           nextDue: "Next Due",
//           overdue: "Overdue",
//           shippingAddress: "Shipping Address",
//           selectAddress: "Select From Existing Address",
//           addAddress: "Add New Address",
//           addressLimitReached: "Address Limit Reached",
//           selectAddressTitle: "Select Address",
//           noSavedAddress: "No saved addresses found",
//           default: "Default",
//           phone: "Phone",
//           edit: "Edit",
//           delete: "Delete",
//           disableAddress: "Disable Address",
//           useAddress: "Use This Address",
//           fullName: "Full Name",
//           altPhone: "Alt Phone",
//           pincode: "Pincode",
//           address1: "Address 1",
//           address2: "Address 2",
//           city: "City",
//           state: "State",
//           landmark: "Landmark",
//           home: "Home",
//           office: "Office",
//           saveAddress: "Save Address",
//           deliveryInstructions: "Delivery Instructions",
//           deliveryPlaceholder: "Call before delivery, leave at gate...",
//           processing: "Processing...",
//           proceed: "Proceed",
//           totalCart: "Total Cart",
//           subtotal: "Subtotal",
//           delivery: "Delivery",
//           discount: "Discount",
//           total: "Total",
//         });
//         return;
//       }

//       setUiText({
//         businessCredit: await translateText("Business Credit", true),
//         limit: await translateText("Limit", true),
//         used: await translateText("Used", true),
//         available: await translateText("Available", true),
//         creditPeriod: await translateText("Credit Period", true),
//         nextDue: await translateText("Next Due", true),
//         overdue: await translateText("Overdue", true),
//         shippingAddress: await translateText("Shipping Address", true),
//         selectAddress: await translateText(
//           "Select From Existing Address",
//           true,
//         ),
//         addAddress: await translateText("Add New Address", true),
//         addressLimitReached: await translateText("Address Limit Reached", true),
//         selectAddressTitle: await translateText("Select Address", true),
//         noSavedAddress: await translateText("No saved addresses found", true),
//         default: await translateText("Default", true),
//         phone: await translateText("Phone", true),
//         edit: await translateText("Edit", true),
//         delete: await translateText("Delete", true),
//         disableAddress: await translateText("Disable Address", true),
//         useAddress: await translateText("Use This Address", true),
//         fullName: await translateText("Full Name", true),
//         altPhone: await translateText("Alt Phone", true),
//         pincode: await translateText("Pincode", true),
//         address1: await translateText("Address 1", true),
//         address2: await translateText("Address 2", true),
//         city: await translateText("City", true),
//         state: await translateText("State", true),
//         landmark: await translateText("Landmark", true),
//         home: await translateText("Home", true),
//         office: await translateText("Office", true),
//         saveAddress: await translateText("Save Address", true),
//         deliveryInstructions: await translateText(
//           "Delivery Instructions",
//           true,
//         ),
//         deliveryPlaceholder: await translateText(
//           "Call before delivery, leave at gate...",
//           true,
//         ),
//         processing: await translateText("Processing...", true),
//         proceed: await translateText("Proceed", true),
//         totalCart: await translateText("Total Cart", true),
//         subtotal: await translateText("Subtotal", true),
//         delivery: await translateText("Delivery", true),
//         discount: await translateText("Discount", true),
//         total: await translateText("Total", true),
//       });
//     };

//     loadTranslations();
//   }, [i18n.language]);

//   useEffect(() => {
//     try {
//       const userData = localStorage.getItem("user");

//       if (userData) {
//         const user = JSON.parse(userData);

//         setFormData((prev) => ({
//           ...prev,

//           name: user?.name || "",

//           phone: user?.phone || "",

//           city: user?.city || "",
//         }));
//       }
//     } catch (err) {
//       console.log("User parse error", err);
//     }
//   }, []);

//   // ✅ ONLY SAVED ADDRESSES
//   const savedAddresses = addresses.filter((a) => a.id !== "current-location");

//   // ✅ ADDRESS LIMIT
//   const addressLimitReached = savedAddresses.length >= 5;

//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const deleteAddress = async (id) => {
//     try {
//       // ✅ REMOVE CURRENT LOCATION PROTECTION
//       if (id === "current-location") {
//         alert("Current location cannot be deleted");

//         return;
//       }

//       // ✅ API DELETE
//       await fetch(`${API}/user-addresses/${id}`, {
//         method: "DELETE",
//       });

//       // ✅ FRONTEND REMOVE
//       setAddresses((prev) => prev.filter((addr) => addr.id !== id));

//       // ✅ RESET SELECTED
//       if (selectedId === id) {
//         const remaining = addresses.filter((addr) => addr.id !== id);

//         // ✅ AUTO SELECT NEXT ADDRESS
//         const nextAddress = remaining.find((a) => a.id !== "current-location");

//         if (nextAddress) {
//           setSelectedId(nextAddress.id);
//         } else {
//           setSelectedId("current-location");
//         }

//         // if (remaining.length > 0) {
//         //   setSelectedId(remaining[0].id);
//         // } else {
//         //   setSelectedId(null);
//         // }
//       }
//     } catch (err) {
//       console.log(err);

//       alert("Delete failed");
//     }
//   };

//   const setDefault = async (id) => {
//     try {
//       await fetch(`${API}/user-addresses/${id}/default`, {
//         method: "PUT",
//       });

//       setAddresses((prev) =>
//         prev.map((addr) => ({
//           ...addr,
//           isDefault: addr.id === id,
//         })),
//       );

//       setSelectedId(id);

//       alert("Default address updated");
//     } catch (err) {
//       console.log(err);

//       alert("Failed to update default");
//     }
//   };

//   const saveAddress = async () => {
//     try {
//       // ✅ REMOVE CURRENT LOCATION
//       const savedAddresses = addresses.filter(
//         (a) => a.id !== "current-location",
//       );

//       // ✅ MAX 5 LIMIT
//       if (!editId && savedAddresses.length >= 5) {
//         alert("Maximum 5 addresses allowed");

//         return;
//       }

//       const finalAddress = `${formData.address1}, ${formData.address2}, ${formData.city}, ${formData.state}`;

//       // ✅ DUPLICATE CHECK
//       const alreadyExists = savedAddresses.some(
//         (addr) =>
//           // ✅ IGNORE CURRENT EDIT ADDRESS
//           addr.id !== editId &&
//           addr.address?.trim().toLowerCase() ===
//             finalAddress.trim().toLowerCase(),
//       );

//       if (alreadyExists) {
//         alert("Address already exists");

//         return;
//       }

//       const res = await fetch(
//         editId ? `${API}/user-addresses/${editId}` : `${API}/user-addresses`,

//         {
//           method: editId ? "PUT" : "POST",

//           headers: {
//             "Content-Type": "application/json",
//           },

//           body: JSON.stringify({
//             contact_name: formData.name,

//             phone: formData.phone,

//             address_line: finalAddress,

//             street: formData.address1,

//             zone: formData.address2,

//             building: formData.landmark,

//             unit_no: formData.altPhone,

//             city: formData.city,

//             country: formData.state,

//             zip_code: formData.pincode,

//             lat: coords?.lat,

//             lng: coords?.lng,

//             address_type: formData.type,

//             is_default: savedAddresses.length === 0,
//           }),
//         },
//       );

//       const newAddress = await res.json();

//       if (!res.ok) {
//         alert("Failed to save address");

//         return;
//       }

//       // ✅ ADD NEW ADDRESS
//       if (editId) {
//         // ✅ UPDATE EXISTING
//         setAddresses((prev) =>
//           prev.map((addr) =>
//             addr.id === editId
//               ? {
//                   ...addr,

//                   name: newAddress.contact_name,

//                   phone: newAddress.phone,

//                   address: newAddress.address_line,

//                   // ✅ IMPORTANT
//                   street: newAddress.street,

//                   zone: newAddress.zone,

//                   building: newAddress.building,

//                   unit_no: newAddress.unit_no,

//                   city: newAddress.city,

//                   country: newAddress.country,

//                   zip_code: newAddress.zip_code,

//                   address_type: newAddress.address_type,
//                 }
//               : addr,
//           ),
//         );
//       } else {
//         // ✅ ADD NEW
//         setAddresses((prev) => [
//           ...prev,

//           {
//             id: newAddress.id,

//             name: newAddress.contact_name,

//             phone: newAddress.phone,

//             address: newAddress.address_line,

//             isDefault: newAddress.is_default,

//             // ✅ IMPORTANT
//             street: newAddress.street,

//             zone: newAddress.zone,

//             building: newAddress.building,

//             unit_no: newAddress.unit_no,

//             city: newAddress.city,

//             country: newAddress.country,

//             zip_code: newAddress.zip_code,

//             address_type: newAddress.address_type,
//           },
//         ]);
//       }

//       setSelectedId(newAddress.id);

//       setShowForm(false);
//       setEditId(null);
//       setFormData({
//         name: "",

//         phone: "",

//         altPhone: "",

//         pincode: "",

//         address1: "",

//         address2: "",

//         city: "",

//         state: "",

//         landmark: "",

//         type: "Home",
//       });

//       alert("Address saved successfully");
//     } catch (err) {
//       console.log(err);

//       alert("Save failed");
//     }
//   };
//   // const handleSubmit = async (e) => {

//   //   e.preventDefault();

//   //   try {

//   //     const TOKEN =
//   //       localStorage.getItem("token");

//   //     // ✅ LOGIN CHECK
//   //     if (!TOKEN) {

//   //       alert("Login expired");

//   //       return;
//   //     }

//   //     // ✅ USE SELECTED ADDRESS DATA
//   //     const customerName =
//   //       selectedAddress?.name ||
//   //       formData.name;

//   //     const customerPhone =
//   //       selectedAddress?.phone ||
//   //       formData.phone;

//   //     // ✅ VALIDATION
//   //     if (!customerName || !customerPhone) {

//   //       alert(
//   //         "Name and phone are required"
//   //       );

//   //       return;
//   //     }

//   //     // ✅ ADDRESS FIX
//   //     const finalAddress =

//   //       selectedAddress?.address ||

//   //       (
//   //         formData.address1 &&
//   //         formData.city
//   //       )

//   //         ? `${formData.address1}, ${formData.city}`

//   //         : null;

//   //     if (!finalAddress) {

//   //       alert("Please enter address");

//   //       return;
//   //     }

//   //     // ✅ LOCATION CHECK
//   //     if (!coords) {

//   //       alert(
//   //         "Location not detected yet"
//   //       );

//   //       return;
//   //     }

//   //     // 🚀 CREATE ORDER
//   //     const res = await fetch(

//   //       `${API}/checkout`,

//   //       {

//   //         method: "POST",

//   //         headers: {

//   //           "Content-Type":
//   //             "application/json",

//   //           Authorization:
//   //             `Bearer ${TOKEN}`,

//   //         },

//   //         body: JSON.stringify({

//   //           // ✅ FIXED
//   //           name: customerName,

//   //           phone: customerPhone,

//   //           address: finalAddress,

//   //           note:
//   //             formData.landmark || "",

//   //           delivery_instructions:
//   //             formData.landmark || "",
//   //           latitude:
//   //             coords?.lat || 0,

//   //           longitude:
//   //             coords?.lng || 0,

//   //         }),

//   //       }
//   //     );

//   //     const data = await res.json();

//   //     // ❌ API ERROR
//   //     if (!res.ok) {

//   //       console.error(
//   //         "Checkout error:",
//   //         data
//   //       );

//   //       alert(
//   //         data?.error ||
//   //         "Checkout failed"
//   //       );

//   //       return;
//   //     }

//   //     // const firstOrder =
//   //     //   data?.orders_created?.[0];

//   //     // if (!firstOrder) {

//   //     //   alert("Order not created");

//   //     //   return;
//   //     // }

//   //     // console.log(
//   //     //   "✅ ORDER CREATED:",
//   //     //   firstOrder
//   //     // );

//   //     // // ✅ STORE ORDER
//   //     // localStorage.setItem(
//   //     //   "order_id",
//   //     //   firstOrder.order_id
//   //     // );

//   //     // localStorage.setItem(
//   //     //   "total_amount",
//   //     //   firstOrder.amount
//   //     // );

//   //     // // 🚀 NAVIGATE
//   //     // navigate("/payment");

//   // const firstOrder =
//   //   data?.orders_created?.[0];

//   // if (!firstOrder) {

//   //   alert("Order not created");

//   //   return;
//   // }

//   // console.log(
//   //   "✅ ORDER CREATED:",
//   //   firstOrder
//   // );

//   // // ✅ SAVE ALL ORDERS
//   // localStorage.setItem(
//   //   "success_orders",
//   //   JSON.stringify(data.orders_created || [])
//   // );

//   // // ✅ OPTIONAL SINGLE ORDER
//   // localStorage.setItem(
//   //   "order_id",
//   //   firstOrder.order_id
//   // );

//   // localStorage.setItem(
//   //   "total_amount",
//   //   firstOrder.amount
//   // );

//   // // 🚀 NAVIGATE
//   // navigate("/payment");

//   //   } catch (err) {

//   //     console.error(
//   //       "❌ Checkout crash:",
//   //       err
//   //     );

//   //     alert(
//   //       "Checkout failed. Try again."
//   //     );
//   //   }
//   // };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // ✅ STOP DOUBLE CLICK
//     if (isSubmitting) return;

//     setIsSubmitting(true);

//     try {
//       const TOKEN = localStorage.getItem("token");

//       // ✅ LOGIN CHECK
//       if (!TOKEN) {
//         alert("Login expired");

//         setIsSubmitting(false);

//         return;
//       }

//       // ✅ USE SELECTED ADDRESS DATA
//       const customerName = selectedAddress?.name || formData.name;

//       const customerPhone = selectedAddress?.phone || formData.phone;

//       // ✅ VALIDATION
//       if (!customerName || !customerPhone) {
//         alert("Name and phone are required");

//         setIsSubmitting(false);

//         return;
//       }

//       // ✅ ADDRESS FIX
//       const finalAddress =
//         selectedAddress?.address || (formData.address1 && formData.city)
//           ? `${formData.address1}, ${formData.city}`
//           : null;

//       if (!finalAddress) {
//         alert("Please enter address");

//         setIsSubmitting(false);

//         return;
//       }

//       // ✅ LOCATION CHECK
//       if (!coords) {
//         alert("Location not detected yet");

//         setIsSubmitting(false);

//         return;
//       }

//       // 🚀 CREATE ORDER
//       const res = await fetch(
//         `${API}/checkout`,

//         {
//           method: "POST",

//           headers: {
//             "Content-Type": "application/json",

//             Authorization: `Bearer ${TOKEN}`,
//           },

//           body: JSON.stringify({
//             name: customerName,

//             phone: customerPhone,

//             address: finalAddress,

//             note: formData.landmark || "",

//             delivery_instructions: formData.landmark || "",

//             latitude: coords?.lat || 0,

//             longitude: coords?.lng || 0,
//           }),
//         },
//       );

//       const data = await res.json();

//       // ❌ API ERROR
//       if (!res.ok) {
//         console.error("Checkout error:", data);

//         alert(data?.error || "Checkout failed");

//         setIsSubmitting(false);

//         return;
//       }

//       const firstOrder = data?.orders_created?.[0];

//       if (!firstOrder) {
//         alert("Order not created");

//         setIsSubmitting(false);

//         return;
//       }

//       console.log("✅ ORDER CREATED:", firstOrder);

//       // ✅ SAVE ALL ORDERS
//       localStorage.setItem(
//         "success_orders",
//         JSON.stringify(data.orders_created || []),
//       );

//       // ✅ OPTIONAL SINGLE ORDER
//       localStorage.setItem("order_id", firstOrder.order_id);

//       localStorage.setItem("total_amount", firstOrder.amount);

//       // ✅ NAVIGATE
//       navigate("/payment");
//     } catch (err) {
//       console.error("❌ Checkout crash:", err);

//       alert("Checkout failed. Try again.");
//     } finally {
//       // ✅ ALWAYS RESET
//       setIsSubmitting(false);
//     }
//   };
//   /* ================= CART ================= */
//   const cartItems = JSON.parse(localStorage.getItem("cart")) || [];

//   const subtotalFromCart = cartItems.reduce(
//     (sum, item) => sum + item.price * item.quantity,
//     0,
//   );

//   const savedSummary = JSON.parse(localStorage.getItem("cart_summary")) || {
//     subtotal: subtotalFromCart,
//     delivery: 0,
//     discount: 0,
//     total: subtotalFromCart,
//   };

//   const { subtotal, delivery, discount, total } = savedSummary;

//   return (
//     <section className="checkout pt_100 pb-80">
//       <div className="container">
//         <div className="row">
//           <div className="col-lg-8">
//             {/* ✅ CREDIT BOX */}
//             {creditInfo && (
//               <div className="credit_summary_box">
//                 <div className="credit_summary_header">
//                   <i className="fas fa-wallet"></i>
//                   <span>{uiText.businessCredit}</span>
//                 </div>

//                 <div className="credit_summary_grid">
//                   <div>
//                     <small>{uiText.limit}</small>
//                     <strong>QAR {creditInfo.credit_limit}</strong>
//                   </div>

//                   <div>
//                     <small>{uiText.used}</small>
//                     <strong>QAR {creditInfo.credit_used}</strong>
//                   </div>

//                   <div>
//                     <small>{uiText.available}</small>
//                     <strong className="credit_available">
//                       QAR {creditInfo.credit_available}
//                     </strong>
//                   </div>

//                   <div>
//                     <small>{uiText.creditPeriod}</small>
//                     <strong>{creditInfo.credit_days} days</strong>
//                   </div>

//                   {creditInfo.next_due_date && (
//                     <div>
//                       <small>{uiText.nextDue}</small>
//                       <strong>
//                         {new Date(
//                           creditInfo.next_due_date,
//                         ).toLocaleDateString()}
//                       </strong>
//                     </div>
//                   )}

//                   {creditInfo.overdue_amount > 0 && (
//                     <div className="credit_overdue">
//                       Overdue:QAR {creditInfo.overdue_amount}
//                     </div>
//                   )}
//                 </div>
//               </div>
//             )}

//             <div className="shipping_address_box">
//               <div className="d-flex justify-content-between align-items-center mb-3">
//                 <h3>{uiText.shippingAddress}</h3>

//                 <div className="d-flex gap-2">
//                   {/* SELECT ADDRESS */}

//                   <button
//                     className="add_address_btn"
//                     onClick={() => setShowAddressPopup(!showAddressPopup)}
//                   >
//                     + {uiText.selectAddress}
//                   </button>

//                   {/* ADD ADDRESS */}

//                   <button
//                     className="add_address_btn"
//                     disabled={addressLimitReached}
//                     onClick={() => {
//                       if (addressLimitReached) {
//                         alert("Maximum 5 addresses allowed");

//                         return;
//                       }

//                       setShowForm(!showForm);

//                       setEditId(null);
//                     }}
//                   >
//                     {addressLimitReached
//                       ? uiText.addressLimitReached
//                       : `+ ${uiText.addAddress}`}
//                   </button>
//                 </div>
//               </div>

//               {/* ================= ADDRESS POPUP ================= */}

//               {showAddressPopup && (
//                 <div className="address_popup_overlay">
//                   <div className="address_popup_modal">
//                     <div className="popup_header">
//                       <h4>{uiText.selectAddressTitle}</h4>

//                       <button
//                         className="popup_close"
//                         onClick={() => setShowAddressPopup(false)}
//                       >
//                         ✕
//                       </button>
//                     </div>

//                     {savedAddresses.length === 0 ? (
//                       <p>{uiText.noSavedAddress}</p>
//                     ) : (
//                       savedAddresses.map((addr) => (
//                         <div
//                           key={addr.id}
//                           className={`address_card ${
//                             selectedId === addr.id ? "active" : ""
//                           }`}
//                         >
//                           <div className="address_row">
//                             <div className="address_left">
//                               <input
//                                 type="radio"
//                                 checked={selectedId === addr.id}
//                                 onChange={() => {
//                                   // ✅ SELECT MANUAL ADDRESS
//                                   setSelectedId(addr.id);

//                                   // ✅ CLOSE POPUP
//                                   setShowAddressPopup(false);
//                                   window.scrollTo({
//                                     top: 0,
//                                     behavior: "smooth",
//                                   });
//                                 }}
//                               />

//                               <div className="address_content">
//                                 <div className="address_header">
//                                   <h5>{addr.name}</h5>

//                                   {addr.isDefault && (
//                                     <span className="default_badge">
//                                       {uiText.default}
//                                     </span>
//                                   )}
//                                 </div>

//                                 <p className="address_text">{addr.address}</p>

//                                 <small>
//                                   {uiText.phone}: {addr.phone}
//                                 </small>
//                               </div>
//                             </div>

//                             <div className="address_right">
//                               {addr.id !== "current-location" && (
//                                 <>
//                                   {/* EDIT */}

//                                   <button
//                                     onClick={() => {
//                                       setEditId(addr.id);

//                                       setShowForm(true);

//                                       setShowAddressPopup(false);

//                                       setFormData({
//                                         name: addr.name || "",

//                                         phone: addr.phone || "",

//                                         altPhone: addr.unit_no || "",

//                                         pincode: addr.zip_code || "",

//                                         address1: addr.street || "",

//                                         address2: addr.zone || "",

//                                         city: addr.city || "",

//                                         state: addr.country || "",

//                                         landmark: addr.building || "",

//                                         type: addr.address_type || "Home",
//                                       });
//                                     }}
//                                   >
//                                     {uiText.edit}
//                                   </button>

//                                   {/* DELETE */}

//                                   <button
//                                     onClick={() => deleteAddress(addr.id)}
//                                   >
//                                     {uiText.delete}
//                                   </button>

//                                   {/* MAKE DEFAULT */}

//                                   {/* {!addr.isDefault && (

//         <button
//           onClick={() =>
//             setDefault(
//               addr.id
//             )
//           }
//         >
//           Make Default
//         </button>

//       )} */}

//                                   {/* ✅ USE / DISABLE ADDRESS */}

//                                   <button
//                                     className={`use_address_btn ${
//                                       selectedId === addr.id ? "active" : ""
//                                     }`}
//                                     onClick={() => {
//                                       // ✅ DISABLE MANUAL ADDRESS
//                                       if (selectedId === addr.id) {
//                                         // ✅ ACTIVATE CURRENT LOCATION
//                                         setSelectedId("current-location");
//                                       } else {
//                                         // ✅ ACTIVATE MANUAL ADDRESS
//                                         setSelectedId(addr.id);
//                                       }

//                                       // ✅ AUTO CLOSE POPUP
//                                       setShowAddressPopup(false);

//                                       // ✅ AUTO BACK TO TOP
//                                       window.scrollTo({
//                                         top: 0,
//                                         behavior: "smooth",
//                                       });
//                                     }}
//                                   >
//                                     {selectedId === addr.id
//                                       ? uiText.disableAddress
//                                       : uiText.useAddress}
//                                   </button>
//                                 </>
//                               )}
//                             </div>
//                           </div>
//                         </div>
//                       ))
//                     )}
//                   </div>
//                 </div>
//               )}

//               {/* ADDRESS LIST */}
//               {/* ================= CURRENT LOCATION ONLY ================= */}

//               {addresses

//                 .filter((addr) => addr.id === "current-location")

//                 .map((addr) => (
//                   <div
//                     key={addr.id}
//                     className={`address_card ${
//                       selectedId === addr.id ? "active" : "inactive_location"
//                     }`}
//                   >
//                     <div className="address_row">
//                       <div className="address_left">
//                         {/* <input
//               type="radio"

//               checked={
//                 selectedId ===
//                 "current-location"
//               }

//               disabled={
//                 selectedId !==
//                 "current-location"
//               }

//               onChange={() => {

//                 // ✅ ONLY IF ENABLED
//                 if (
//                   selectedId !==
//                   "current-location"
//                 ) {
//                   return;
//                 }

//                 setSelectedId(
//                   "current-location"
//                 );

//               }}
//             /> */}

//                         <input
//                           type="radio"
//                           checked={selectedId === "current-location"}
//                           disabled={selectedId !== "current-location"}
//                           onChange={() => {
//                             // ✅ ONLY CURRENT LOCATION ACTIVE
//                             setSelectedId("current-location");
//                           }}
//                         />

//                         <div className="address_content">
//                           <div className="address_header">
//                             <h5>{addr.name}</h5>
//                           </div>

//                           <p className="address_text">{addr.address}</p>

//                           <small className="phone_text">
//                             Phone: {addr.phone}
//                           </small>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 ))}

//               {/* FORM */}
//               <div className={`address_form_wrapper ${showForm ? "open" : ""}`}>
//                 {showForm && (
//                   <form
//                     className="checkout_form mt-4"
//                     onSubmit={(e) => {
//                       e.preventDefault();
//                       saveAddress();
//                     }}
//                   >
//                     <div className="row">
//                       <div className="col-md-6">
//                         <input
//                           name="name"
//                           value={formData.name}
//                           onChange={handleChange}
//                           placeholder={uiText.fullName}
//                         />
//                       </div>

//                       <div className="col-md-6">
//                         <input
//                           name="phone"
//                           value={formData.phone}
//                           onChange={handleChange}
//                           placeholder={uiText.phone}
//                         />
//                       </div>

//                       <div className="col-md-6">
//                         <input
//                           name="altPhone"
//                           value={formData.altPhone}
//                           onChange={handleChange}
//                           placeholder={uiText.altPhone}
//                         />
//                       </div>

//                       <div className="col-md-6">
//                         <input
//                           name="pincode"
//                           value={formData.pincode}
//                           onChange={handleChange}
//                           placeholder={uiText.pincode}
//                         />
//                       </div>

//                       <div className="col-12">
//                         <input
//                           name="address1"
//                           value={formData.address1}
//                           onChange={handleChange}
//                           placeholder={uiText.address1}
//                         />
//                       </div>

//                       <div className="col-12">
//                         <input
//                           name="address2"
//                           value={formData.address2}
//                           onChange={handleChange}
//                           placeholder={uiText.address2}
//                         />
//                       </div>

//                       <div className="col-md-6">
//                         <input
//                           name="city"
//                           value={formData.city}
//                           onChange={handleChange}
//                           placeholder={uiText.city}
//                         />
//                       </div>

//                       <div className="col-md-6">
//                         <input
//                           name="state"
//                           value={formData.state}
//                           onChange={handleChange}
//                           placeholder={uiText.state}
//                         />
//                       </div>

//                       <div className="col-md-6">
//                         <input
//                           name="landmark"
//                           value={formData.landmark}
//                           onChange={handleChange}
//                           placeholder={uiText.landmark}
//                         />
//                       </div>

//                       <div className="col-12 mt-3">
//                         <label>
//                           <input
//                             type="radio"
//                             name="type"
//                             value="Home"
//                             onChange={handleChange}
//                           />{" "}
//                           {uiText.home}
//                         </label>
//                         <label>
//                           <input
//                             type="radio"
//                             name="type"
//                             value="Office"
//                             onChange={handleChange}
//                           />{" "}
//                           {uiText.office}
//                         </label>
//                       </div>

//                       <div className="col-12 mt-4">
//                         <button type="submit" className="common_btn">
//                           {uiText.saveAddress}
//                         </button>
//                       </div>
//                     </div>
//                   </form>
//                 )}
//               </div>

//               {/* DELIVERY INSTRUCTIONS */}
//               <div className="mt-4">
//                 <label>{uiText.deliveryInstructions}</label>

//                 <textarea
//                   className="address_card"
//                   rows="3"
//                   placeholder={uiText.deliveryPlaceholder}
//                   value={formData.landmark}
//                   onChange={(e) =>
//                     setFormData({
//                       ...formData,
//                       landmark: e.target.value,
//                     })
//                   }
//                 />
//               </div>

//               {/* PROCEED BUTTON */}
//               <button
//                 onClick={handleSubmit}
//                 className="common_btn mt-3"
//                 disabled={isSubmitting}
//               >
//                 {isSubmitting
//                   ? uiText.processing
//                   : uiText.proceed}
//               </button>

//               {/* {creditInfo?.overdue_amount > 0 && (     
//               <p style={{ color: "red", marginTop: "10px" }}>
//                 ⚠️ Your account has overdue amount of QAR {creditInfo.overdue_amount}.  
//                 Please clear dues to use credit.
//               </p>
//             )} */}
//             </div>
//           </div>

//           {/* CART */}
//           <div className="col-lg-4 col-md-8">
//             <div className="cart_sidebar">
//               <h3>{uiText.totalCart}  ({cartItems.length})</h3>
//               <div className="cart_sidebar_info">
//                 <h4>
//                   {uiText.subtotal} : <span>QAR {subtotal.toFixed(2)}</span>
//                 </h4>
//                 <p>
//                   {uiText.delivery} : <span>QAR {delivery}</span>
//                 </p>
//                 <p>
//                   {uiText.discount} : <span>-QAR {discount}</span>
//                 </p>
//                 <h5>
//                   {uiText.total} : <span>QAR {total.toFixed(2)}</span>
//                 </h5>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default CheckItems;

import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
//import M_API from "../config/api";

const API = "https://api.mahal.qa/api";

const CheckItems = () => {
  const navigate = useNavigate();

  const [addresses, setAddresses] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [showAddressPopup, setShowAddressPopup] = useState(false);
  const [editId, setEditId] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const selectedAddress = addresses.find(a => a.id === selectedId);

  const [coords, setCoords] = useState(null);

  // Dynamic delivery
  const [distanceKm, setDistanceKm] = useState(0);
  const [deliveryCharge, setDeliveryCharge] = useState(0);

  // ✅ CREDIT STATES
  // const [paymentMethod, setPaymentMethod] = useState("COD");
  // const [paymentMethod, setPaymentMethod] = useState("");
  const [creditInfo, setCreditInfo] = useState(null);

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    altPhone: "",
    pincode: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    landmark: "",
    type: "Home",
  });
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    fetch(`${API}/restaurant/profile`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((user) => {
        const newId = Date.now();

        // ✅ form set
        setFormData({
          name: user?.name || "",
          phone: user?.phone || "",
          altPhone: "",
          pincode: "",
          address1: "",
          address2: "",
          city: "",
          state: "",
          landmark: "",
          type: "Home",
        });

        // ✅ address create HERE (IMPORTANT)


        setSelectedId(newId);
      })
      .catch((err) => console.log(err));
  }, []);
  /* ================= CREDIT FETCH ================= */
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    fetch(`${API}/restaurant/credit-info`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => res.json())
      .then(setCreditInfo)
      .catch(() => { });
  }, []);


  /* ================= AUTO LOCATION ================= */
  useEffect(() => {

    if (navigator.geolocation) {

      navigator.geolocation.getCurrentPosition(

        async (pos) => {

          const { latitude, longitude } = pos.coords;

          setCoords({
            lat: latitude,
            lng: longitude,
          });

          try {

            const res = await fetch(
              `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`
            );

            const data = await res.json();

            const addressText =
              data.display_name || "Current Location";

            // ✅ CURRENT LOCATION OBJECT
            const tokenUser =
              JSON.parse(
                localStorage.getItem("user") || "{}"
              );

            const currentLocationAddress = {

              id: "current-location",

              // ✅ USER NAME
              name:
                formData.name ||
                tokenUser?.name ||
                "Current Location",

              // ✅ USER PHONE
              phone:
                formData.phone ||
                tokenUser?.phone ||
                "",

              address: addressText,

              isDefault: false,

            };

            setAddresses((prev) => {

              // ✅ REMOVE OLD CURRENT LOCATION
              const savedAddresses = prev.filter(
                (a) => a.id !== "current-location"
              );

              // ✅ KEEP MANUAL SAVED ADDRESSES
              // ✅ ADD ONLY LATEST CURRENT LOCATION
              return [
                currentLocationAddress,
                ...savedAddresses,
              ];
            });

            // ✅ SELECT CURRENT LOCATION
            setSelectedId("current-location");

          } catch (err) {

            console.log(err);
          }
        },

        (err) => {

          console.log("Location error:", err);
        }

      );
    }

  }, []);
  /* ================= USER AUTO FILL ================= */

  useEffect(() => {

    const fetchSavedAddresses = async () => {

      try {

        const res = await fetch(
          `${API}/user-addresses`
        );

        const data = await res.json();

        if (
          Array.isArray(data) &&
          data.length > 0
        ) {

          const formatted = data.map((addr) => ({

            id: addr.id,

            name: addr.contact_name,

            phone: addr.phone,

            address: addr.address_line,

            isDefault: addr.is_default,

            // ✅ EXTRA FIELDS
            street: addr.street,

            zone: addr.zone,

            building: addr.building,

            unit_no: addr.unit_no,

            city: addr.city,

            country: addr.country,

            zip_code: addr.zip_code,

            address_type: addr.address_type,
            lat: addr.lat,
            lng: addr.lng,

          }));

          setAddresses((prev) => {

            const currentLocation = prev.find(
              (a) => a.id === "current-location"
            );

            // ✅ CURRENT LOCATION EXISTS
            if (currentLocation) {

              const allAddresses = [
                currentLocation,
                ...formatted
              ];

              // ✅ FIND DEFAULT
              const defaultAddress =
                formatted.find(
                  (a) => a.isDefault
                );

              // ✅ AUTO SELECT DEFAULT
              if (defaultAddress) {

                setSelectedId(
                  defaultAddress.id
                );

              } else if (!selectedId) {

                setSelectedId(
                  allAddresses[0].id
                );
              }

              return allAddresses;
            }

            // ✅ NO CURRENT LOCATION
            const defaultAddress =
              formatted.find(
                (a) => a.isDefault
              );

            if (defaultAddress) {

              setSelectedId(
                defaultAddress.id
              );
            }

            return formatted;

          });

        }

      } catch (err) {

        console.log(
          "Address fetch error",
          err
        );
      }
    };

    fetchSavedAddresses();

  }, []);
  useEffect(() => {

    try {

      const userData =
        localStorage.getItem("user");

      if (userData) {

        const user =
          JSON.parse(userData);

        setFormData((prev) => ({

          ...prev,

          name: user?.name || "",

          phone: user?.phone || "",

          city: user?.city || "",

        }));
      }

    } catch (err) {

      console.log(
        "User parse error",
        err
      );
    }

  }, []);

  // ✅ ONLY SAVED ADDRESSES
  const savedAddresses = addresses.filter(
    (a) => a.id !== "current-location"
  );

  // ✅ ADDRESS LIMIT
  const addressLimitReached =
    savedAddresses.length >= 5;

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const deleteAddress = async (id) => {

    try {

      // ✅ REMOVE CURRENT LOCATION PROTECTION
      if (id === "current-location") {

        alert("Current location cannot be deleted");

        return;
      }

      // ✅ API DELETE
      await fetch(`${API}/user-addresses/${id}`, {
        method: "DELETE",
      });

      // ✅ FRONTEND REMOVE
      setAddresses((prev) =>
        prev.filter((addr) => addr.id !== id)
      );

      // ✅ RESET SELECTED
      if (selectedId === id) {

        const remaining = addresses.filter(
          (addr) => addr.id !== id
        );

        // ✅ AUTO SELECT NEXT ADDRESS
        const nextAddress = remaining.find(
          (a) => a.id !== "current-location"
        );

        if (nextAddress) {

          setSelectedId(nextAddress.id);

        } else {

          setSelectedId("current-location");
        }


      }
    } catch (err) {

      console.log(err);

      alert("Delete failed");
    }
  };

  const setDefault = async (id) => {

    try {

      await fetch(
        `${API}/user-addresses/${id}/default`,
        {
          method: "PUT",
        }
      );

      setAddresses((prev) =>
        prev.map((addr) => ({
          ...addr,
          isDefault: addr.id === id,
        }))
      );

      setSelectedId(id);

      alert("Default address updated");

    } catch (err) {

      console.log(err);

      alert("Failed to update default");
    }
  };



  const saveAddress = async () => {

    try {

      // ✅ REMOVE CURRENT LOCATION
      const savedAddresses = addresses.filter(
        (a) => a.id !== "current-location"
      );


      // ✅ MAX 5 LIMIT
      if (!editId && savedAddresses.length >= 5) {

        alert("Maximum 5 addresses allowed");

        return;
      }

      const finalAddress =
        `${formData.address1}, ${formData.address2}, ${formData.city}, ${formData.state}`;

      // ✅ DUPLICATE CHECK
      const alreadyExists = savedAddresses.some(
        (addr) =>

          // ✅ IGNORE CURRENT EDIT ADDRESS
          addr.id !== editId &&

          addr.address?.trim().toLowerCase() ===
          finalAddress.trim().toLowerCase()
      );

      if (alreadyExists) {

        alert("Address already exists");

        return;
      }

      const query = encodeURIComponent(
        `${formData.address1},
   ${formData.address2},
   ${formData.city},
   ${formData.state}`
      );

      const geoRes = await fetch(
        `https://nominatim.openstreetmap.org/search?q=${query}&format=json&limit=1`
      );

      const geoData = await geoRes.json();

      const lat = geoData?.[0]?.lat
        ? Number(geoData[0].lat)
        : coords?.lat;

      const lng = geoData?.[0]?.lon
        ? Number(geoData[0].lon)
        : coords?.lng;

      const res = await fetch(

        editId
          ? `${API}/user-addresses/${editId}`
          : `${API}/user-addresses`,

        {

          method: editId ? "PUT" : "POST",

          headers: {
            "Content-Type": "application/json",
          },

          body: JSON.stringify({

            contact_name: formData.name,

            phone: formData.phone,

            address_line: finalAddress,

            street: formData.address1,

            zone: formData.address2,

            building: formData.landmark,

            unit_no: formData.altPhone,

            city: formData.city,

            country: formData.state,

            zip_code: formData.pincode,

            lat: lat,
            lng: lng,


            address_type: formData.type,

            is_default: savedAddresses.length === 0

          }),
        }
      );


      const newAddress = await res.json();

      if (!res.ok) {

        alert("Failed to save address");

        return;
      }

      // ✅ ADD NEW ADDRESS
      if (editId) {

        // ✅ UPDATE EXISTING
        setAddresses((prev) =>
          prev.map((addr) =>
            addr.id === editId
              ? {

                ...addr,

                name: newAddress.contact_name,

                phone: newAddress.phone,

                address: newAddress.address_line,

                // ✅ IMPORTANT
                street: newAddress.street,

                zone: newAddress.zone,

                building: newAddress.building,

                unit_no: newAddress.unit_no,

                city: newAddress.city,

                country: newAddress.country,

                zip_code: newAddress.zip_code,

                address_type:
                  newAddress.address_type,

              }
              : addr
          )
        );

      } else {

        // ✅ ADD NEW
        setAddresses((prev) => [

          ...prev,

          {
            id: newAddress.id,

            name: newAddress.contact_name,

            phone: newAddress.phone,

            address: newAddress.address_line,

            isDefault: newAddress.is_default,

            // ✅ IMPORTANT
            street: newAddress.street,

            zone: newAddress.zone,

            building: newAddress.building,

            unit_no: newAddress.unit_no,

            city: newAddress.city,

            country: newAddress.country,

            zip_code: newAddress.zip_code,

            address_type:
              newAddress.address_type,

            lat: newAddress.lat,
            lng: newAddress.lng,

          },

        ]);
      }

      setSelectedId(newAddress.id);

      setShowForm(false);
      setEditId(null);
      setFormData({

        name: "",

        phone: "",

        altPhone: "",

        pincode: "",

        address1: "",

        address2: "",

        city: "",

        state: "",

        landmark: "",

        type: "Home",

      });

      alert("Address saved successfully");

    } catch (err) {

      console.log(err);

      alert("Save failed");
    }
  };

  const handleSubmit = async (e) => {

    e.preventDefault();

    // ✅ STOP DOUBLE CLICK
    if (isSubmitting) return;

    setIsSubmitting(true);

    try {

      const TOKEN =
        localStorage.getItem("token");

      // ✅ LOGIN CHECK
      if (!TOKEN) {

        alert("Login expired");

        setIsSubmitting(false);

        return;
      }

      // ✅ USE SELECTED ADDRESS DATA
      const customerName =
        selectedAddress?.name ||
        formData.name;

      const customerPhone =
        selectedAddress?.phone ||
        formData.phone;

      // ✅ VALIDATION
      if (!customerName || !customerPhone) {

        alert(
          "Name and phone are required"
        );

        setIsSubmitting(false);

        return;
      }

      // ✅ ADDRESS FIX
      const finalAddress =
        selectedAddress?.address ||

          (
            formData.address1 &&
            formData.city
          )

          ? `${formData.address1}, ${formData.city}`

          : null;

      if (!finalAddress) {

        alert("Please enter address");

        setIsSubmitting(false);

        return;
      }

      // ✅ LOCATION CHECK
      if (!coords) {

        alert(
          "Location not detected yet"
        );

        setIsSubmitting(false);

        return;
      }



      // 🚀 CREATE ORDER
      const res = await fetch(

        `${API}/checkout`,

        {

          method: "POST",

          headers: {

            "Content-Type":
              "application/json",

            Authorization:
              `Bearer ${TOKEN}`,

          },

          body: JSON.stringify({

            name: customerName,

            phone: customerPhone,

            address: finalAddress,

            note:
              formData.landmark || "",

            delivery_instructions:
              formData.landmark || "",

            latitude:
              selectedId === "current-location"
                ? coords?.lat
                : selectedAddress?.lat,

            longitude:
              selectedId === "current-location"
                ? coords?.lng
                : selectedAddress?.lng,
          }),

        }
      );

      const data = await res.json();

      // ❌ API ERROR
      if (!res.ok) {

        console.error(
          "Checkout error:",
          data
        );

        alert(
          data?.error ||
          "Checkout failed"
        );

        setIsSubmitting(false);

        return;
      }

      const firstOrder =
        data?.orders_created?.[0];

      if (!firstOrder) {

        alert("Order not created");

        setIsSubmitting(false);

        return;
      }

      console.log(
        "✅ ORDER CREATED:",
        firstOrder
      );

      // ✅ SAVE ALL ORDERS
      localStorage.setItem(
        "success_orders",
        JSON.stringify(
          data.orders_created || []
        )
      );

      // ✅ OPTIONAL SINGLE ORDER
      localStorage.setItem(
        "order_id",
        firstOrder.order_id
      );

      localStorage.setItem(
        "total_amount",
        firstOrder.amount
      );
      localStorage.setItem(
        "cart_summary",
        JSON.stringify({
          subtotal,
          delivery,
          discount,
          total,
        })
      );

      // ✅ NAVIGATE
      navigate("/payment");

    } catch (err) {

      console.error(
        "❌ Checkout crash:",
        err
      );

      alert(
        "Checkout failed. Try again."
      );

    } finally {

      // ✅ ALWAYS RESET
      setIsSubmitting(false);

    }
  };
  /* ================= CART ================= */
  const cartItems = JSON.parse(localStorage.getItem("cart")) || [];
  console.log(cartItems);
  useEffect(() => {

    if (cartItems.length === 0) return;

    const supplierLat = Number(cartItems[0]?.supplier_lat);
    const supplierLng = Number(cartItems[0]?.supplier_lng);

    let customerLat;
    let customerLng;

    if (selectedId === "current-location") {

      customerLat = coords?.lat;
      customerLng = coords?.lng;

    } else {

      const addr = addresses.find(a => a.id === selectedId);

      customerLat = Number(addr?.lat);
      customerLng = Number(addr?.lng);
    }

    if (
      !supplierLat ||
      !supplierLng ||
      !customerLat ||
      !customerLng
    ) {
      return;
    }

    const R = 6371;

    const dLat =
      (customerLat - supplierLat) * Math.PI / 180;

    const dLng =
      (customerLng - supplierLng) * Math.PI / 180;

    const a =
      Math.sin(dLat / 2) ** 2 +
      Math.cos(supplierLat * Math.PI / 180) *
      Math.cos(customerLat * Math.PI / 180) *
      Math.sin(dLng / 2) ** 2;

    const c =
      2 * Math.atan2(
        Math.sqrt(a),
        Math.sqrt(1 - a)
      );

    const km = Math.ceil(R * c);

    let charge = 0;

    if (km <= 3) {
      charge = 15;
    } else if (km <= 5) {
      charge = 25;
    } else if (km <= 8) {
      charge = 40;
    } else if (km <= 10) {
      charge = 55;
    } else {
      charge = 55 + ((km - 10) * 5);
    }

    setDistanceKm(km);
    setDeliveryCharge(charge);

  }, [selectedId, addresses, coords, cartItems]);

  const subtotalFromCart = cartItems.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0
  );


  const cartSummary =
    JSON.parse(localStorage.getItem("cart_summary")) || {};

  const subtotal =
    Number(cartSummary.subtotal || subtotalFromCart);

  const discount =
    Number(cartSummary.discount || 0);

  const delivery = deliveryCharge;

  const total =
    (subtotal - discount) + delivery;

  return (
    <section className="checkout pt_100 pb-80">
      <div className="container">
        <div className="row">

          <div className="col-lg-8">
            {/* ✅ CREDIT BOX */}
            {creditInfo && (
              <div className="credit_summary_box">

                <div className="credit_summary_header">
                  <i className="fas fa-wallet"></i>
                  <span>Business Credit</span>
                </div>

                <div className="credit_summary_grid">

                  <div>
                    <small>Limit</small>
                    <strong>QAR  {creditInfo.credit_limit}</strong>
                  </div>

                  <div>
                    <small>Used</small>
                    <strong>QAR  {creditInfo.credit_used}</strong>
                  </div>

                  <div>
                    <small>Available</small>
                    <strong className="credit_available">
                      QAR  {creditInfo.credit_available}
                    </strong>
                  </div>

                  <div>
                    <small>Credit Period</small>
                    <strong>{creditInfo.credit_days} days</strong>
                  </div>

                  {creditInfo.next_due_date && (
                    <div>
                      <small>Next Due</small>
                      <strong>
                        {new Date(creditInfo.next_due_date).toLocaleDateString()}
                      </strong>
                    </div>
                  )}

                  {creditInfo.overdue_amount > 0 && (
                    <div className="credit_overdue">
                      Overdue:QAR  {creditInfo.overdue_amount}
                    </div>
                  )}

                </div>
              </div>
            )}

            <div className="shipping_address_box">
              <div className="d-flex justify-content-between align-items-center mb-3">

                <h3>Shipping Address</h3>


                <div className="d-flex gap-2">

                  <button
                    className="add_address_btn"
                    onClick={() =>
                      setShowAddressPopup(
                        !showAddressPopup
                      )
                    }
                  >
                    + Select From Existing Address
                  </button>

                  <button
                    className="add_address_btn"
                    onClick={() => {

                      setSelectedId("current-location");

                      navigator.geolocation.getCurrentPosition(
                        async (pos) => {
                          const { latitude, longitude } =
                            pos.coords;

                          setCoords({
                            lat: latitude,
                            lng: longitude,
                          });
                        }
                      );

                      window.scrollTo({
                        top: 0,
                        behavior: "smooth",
                      });
                    }}
                  >
                    Use Current Address
                  </button>

                  <button
                    className="add_address_btn"
                    disabled={addressLimitReached}
                    onClick={() => {
                      if (addressLimitReached) {
                        alert("Maximum 5 addresses allowed");
                        return;
                      }

                      setShowForm(!showForm);
                      setEditId(null);
                    }}
                  >
                    {addressLimitReached
                      ? "Address Limit Reached"
                      : "+ Add New Address"}
                  </button>

                </div>



              </div>

              {/* ================= ADDRESS POPUP ================= */}

              {showAddressPopup && (

                <div className="address_popup_overlay">

                  <div className="address_popup_modal">

                    <div className="popup_header">

                      <h4>Select Address</h4>

                      <button
                        className="popup_close"
                        onClick={() =>
                          setShowAddressPopup(false)
                        }
                      >
                        ✕
                      </button>

                    </div>

                    {savedAddresses.length === 0 ? (

                      <p>No saved addresses found</p>

                    ) : (

                      savedAddresses.map((addr) => (

                        <div
                          key={addr.id}
                          className={`address_card ${selectedId === addr.id
                            ? "active"
                            : ""
                            }`}
                        >

                          <div className="address_row">

                            <div className="address_left">

                              <input
                                type="radio"
                                checked={
                                  selectedId === addr.id
                                }
                                onChange={() => {

                                  // ✅ SELECT MANUAL ADDRESS
                                  setSelectedId(addr.id);

                                  if (addr.lat && addr.lng) {
                                    setCoords({
                                      lat: Number(addr.lat),
                                      lng: Number(addr.lng),
                                    });
                                  }

                                  setShowAddressPopup(false);

                                  window.scrollTo({
                                    top: 0,
                                    behavior: "smooth",
                                  });
                                  window.scrollTo({
                                    top: 0,
                                    behavior: "smooth",
                                  });

                                }}
                              />

                              <div className="address_content">

                                <div className="address_header">

                                  <h5>{addr.name}</h5>

                                  {addr.isDefault && (

                                    <span className="default_badge">

                                      Default

                                    </span>

                                  )}

                                </div>

                                <p className="address_text">

                                  {addr.address}

                                </p>

                                <small className="phone_text">

                                  Phone: {addr.phone}

                                </small>

                              </div>

                            </div>

                            <div className="address_right">

                              {addr.id !==
                                "current-location" && (
                                  <>

                                    {/* EDIT */}

                                    <button
                                      onClick={() => {

                                        setEditId(addr.id);

                                        setShowForm(true);

                                        setShowAddressPopup(false);

                                        setFormData({

                                          name:
                                            addr.name || "",

                                          phone:
                                            addr.phone || "",

                                          altPhone:
                                            addr.unit_no || "",

                                          pincode:
                                            addr.zip_code || "",

                                          address1:
                                            addr.street || "",

                                          address2:
                                            addr.zone || "",

                                          city:
                                            addr.city || "",

                                          state:
                                            addr.country || "",

                                          landmark:
                                            addr.building || "",

                                          type:
                                            addr.address_type ||
                                            "Home",

                                        });

                                      }}
                                    >
                                      Edit
                                    </button>

                                    {/* DELETE */}

                                    <button
                                      onClick={() =>
                                        deleteAddress(
                                          addr.id
                                        )
                                      }
                                    >
                                      Delete
                                    </button>



                                    {/* ✅ USE / DISABLE ADDRESS */}

                                    <button
                                      className={`use_address_btn ${selectedId === addr.id
                                        ? "active"
                                        : ""
                                        }`}
                                      onClick={() => {

                                        if (selectedId === addr.id) {


                                          setSelectedId("current-location");

                                          navigator.geolocation.getCurrentPosition(
                                            async (pos) => {
                                              const { latitude, longitude } = pos.coords;

                                              setCoords({
                                                lat: latitude,
                                                lng: longitude,
                                              });
                                            }
                                          );


                                        } else {

                                          setSelectedId(addr.id);

                                          setCoords({
                                            lat: Number(addr.lat),
                                            lng: Number(addr.lng),
                                          });
                                        }

                                        setShowAddressPopup(false);

                                        // ✅ AUTO BACK TO TOP
                                        window.scrollTo({
                                          top: 0,
                                          behavior: "smooth",
                                        });

                                      }}
                                    >

                                      {selectedId === addr.id
                                        ? "Disable Address"
                                        : "Use This Address"}

                                    </button>

                                  </>
                                )}

                            </div>

                          </div>

                        </div>

                      ))

                    )}

                  </div>

                </div>

              )}

              {/* ADDRESS LIST */}
              {/* ================= CURRENT LOCATION ONLY ================= */}


              {selectedAddress && (
                <div
                  key={selectedAddress.id}
                  className={`address_card ${selectedId === selectedAddress.id
                      ? "active"
                      : "inactive_location"
                    }`}
                >
                  <div className="address_row">
                    <div className="address_left">
                      <input
                        type="radio"
                        checked={true}
                        onChange={() => { }}
                      />

                      <div className="address_content">
                        <div className="address_header">
                          <h5>{selectedAddress.name}</h5>
                        </div>

                        <p className="address_text">
                          {selectedAddress.address}
                        </p>

                        <small className="phone_text">
                          Phone: {selectedAddress.phone}
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              )}




              {/* FORM */}
              <div className={`address_form_wrapper ${showForm ? "open" : ""}`}>
                {showForm && (

                  <form
                    className="checkout_form mt-4"
                    onSubmit={(e) => {
                      e.preventDefault();
                      saveAddress();
                    }}
                  >
                    <div className="row">

                      <div className="col-md-6">
                        <input className="check_input" name="name" value={formData.name} onChange={handleChange} placeholder="Full Name" />
                      </div>

                      <div className="col-md-6">
                        <input className="check_input" name="phone" value={formData.phone} onChange={handleChange} placeholder="Phone" />
                      </div>

                      <div className="col-md-6">
                        <input className="check_input" name="altPhone" value={formData.altPhone} onChange={handleChange} placeholder="Alt Phone" />
                      </div>

                      <div className="col-md-6">
                        <input className="check_input" name="pincode" value={formData.pincode} onChange={handleChange} placeholder="Pincode" />
                      </div>

                      <div className="col-12">
                        <input className="check_input" name="address1" value={formData.address1} onChange={handleChange} placeholder="Address 1" />
                      </div>

                      <div className="col-12">
                        <input className="check_input" name="address2" value={formData.address2} onChange={handleChange} placeholder="Address 2" />
                      </div>

                      <div className="col-md-6">
                        <input className="check_input" name="city" value={formData.city} onChange={handleChange} placeholder="City" />
                      </div>

                      <div className="col-md-6">
                        <input className="check_input" name="state" value={formData.state} onChange={handleChange} placeholder="State" />
                      </div>

                      <div className="col-md-6">
                        <input className="check_input" name="landmark" value={formData.landmark} onChange={handleChange} placeholder="Landmark" />
                      </div>

                      <div className="col-12 mt-3 check_radio" >
                        <label>
                          <input id="check_radio" type="radio" name="type" value="Home" onChange={handleChange} /> Home
                        </label>
                        <label>
                          <input id="check_radio" type="radio" name="type" value="Office" onChange={handleChange} /> Office
                        </label>
                      </div>

                      <div className="col-12 mt-4">
                        <button type="submit" className="common_btn">
                          Save Address
                        </button>
                      </div>

                    </div>
                  </form>

                )}
              </div>

              {/* DISTANCE */}
              {/* <div
                className="address_card mt-3"
                style={{
                  padding: "15px",
                  marginBottom: "15px"
                }}
              >
                <strong>Distance :</strong> {distanceKm} KM
              </div> */}

              {/* DELIVERY INSTRUCTIONS */}
              <div className="mt-4">

                <label>
                  Delivery Instructions
                </label>

                <textarea
                  className="address_card"
                  rows="3"
                  placeholder="Call before delivery, leave at gate..."
                  value={formData.landmark}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      landmark: e.target.value,
                    })
                  }
                />

              </div>

              {/* PROCEED BUTTON */}
              <button
                onClick={handleSubmit}
                className="common_btn mt-3"
                disabled={isSubmitting}
              >
                {isSubmitting
                  ? "Processing..."
                  : "Proceed"}
              </button>

              {/* {creditInfo?.overdue_amount > 0 && (
              <p style={{ color: "red", marginTop: "10px" }}>
                ⚠️ Your account has overdue amount of QAR {creditInfo.overdue_amount}.  
                Please clear dues to use credit.
              </p>
            )} */}
            </div>

          </div>

          {/* CART */}
          <div className="col-lg-4 col-md-8">
            <div className="cart_sidebar">
              <h3>Total Cart ({cartItems.length})</h3>
              <div className="cart_sidebar_info">
                <h4>Subtotal : <span>QAR {subtotal.toFixed(2)}</span></h4>
                {/* <p>Distance : <span>{distanceKm} KM</span></p> */}

                <p>Delivery : <span>QAR {delivery}</span></p>
                <p>Discount : <span>QAR {discount}</span></p>
                <h5>Total : <span>QAR {total.toFixed(2)}</span></h5>


              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default CheckItems;